import script from "./queryPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./queryPrice.vue?vue&type=script&setup=true&lang=js"

import "./queryPrice.vue?vue&type=style&index=0&id=d7f054ee&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7f054ee"]])

export default __exports__